import { render, staticRenderFns } from "./Notch.vue?vue&type=template&id=64f7c63d"
import script from "./Notch.vue?vue&type=script&lang=js"
export * from "./Notch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports